import { Injectable } from '@angular/core';
import { AppSettings } from '../app.settings';
import { Http, RequestOptions, URLSearchParams } from '@angular/http';
import { CommonRequestService } from './common-request.service';

export interface EsriUser {
	username: string;
	email: string;
}
export interface ADUser {
	username: string;
	email: string;
}

@Injectable()
export class EsriUserService {

	esriToken: string;
	esriUserInfo: {
		orgId: string;
		email: string
	};
	constructor(
		private http: Http,
		private requestService: CommonRequestService
	) { }

	// getEsriPortalId() {
	// 	return new Promise((resolve, reject) => {
	// 		const url = AppSettings.esriServiceRootUrl + '/portals/self';
	// 		this.http.get(url);
	// 	});
	// }
	// userName e.g. lis
	getEsriUserInfo(userName: string, token: string) {
		return new Promise<any>((resolve, reject) => {
			const url = AppSettings.esriServiceRootUrl + '/community/users/' + userName;
			this.http.get(url, {
				params: {
					token: token,
					f: 'json'
				}
			})
			.subscribe((rsp) => {
				const json = rsp.json();
				if (json.error) {
					console.log(json);
					reject(json.error);
				} else {
					this.esriUserInfo = json;
					resolve(this.esriUserInfo);
				}
			}, err => reject(err));
		});
	}
	// Please notice only do this type of call after user has been authenticated
	getTokenWithUserEmail(email) {
		return new Promise<any>((resolve, reject) => {
			const url = AppSettings.serviceRootUrl + 'admin/login';
			const body: any = {
				email: email            };
			this.http.post(url, body)
			.subscribe((rsp: any) => {
				resolve(rsp.json());
			}, err => reject(err));
		});
	}

	getEsriUsers() {
		return new Promise<EsriUser[]>((resolve, reject) => {
			const url = AppSettings.esriServiceRootUrl + '/portals/' + this.esriUserInfo.orgId + '/users';
			this.http.get(url, {
				params: {
					f: 'json',
					token: this.esriToken
				}
			})
			.subscribe((rsp: any) => {
				const json = rsp.json();
				if (json.error) {
					reject(json.error);
					console.log(json);
				} else {
					resolve(json.users);
				}
			}, err => reject(err));
		});
	}

// AD
	getExternalUserList(adminEmail: string) {
		return new Promise<ADUser[]>((resolve, reject) => {
			const url = AppSettings.serviceRootUrl + 'admin/externalUserList';
			const params: URLSearchParams = new URLSearchParams();
			const options: RequestOptions = new RequestOptions();
			params.set('email', adminEmail);
			options.params = params;
			this.requestService.requestGet(url, options, (rsp) => {
				const users: ADUser[] = [];
				if (rsp && rsp.data) {
					rsp.data.forEach(d => {
						if (d.mail) {
							const splits = d.userPrincipalName.split('@');
							users.push({
								username: splits[0],
								email: d.mail
							});
						}
					})
				}
				resolve(users);
			}, err => reject(err))
		});
	}

}



// WEBPACK FOOTER //
// ./src/app/common-services/esri-user.service.ts